import { Alert, Button, Center, Loader, PasswordInput, Stack, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { usePasswordLinkInfo, useSetPassword } from "../../api/auth";
import { useErrorText } from "../../api/errors";
import { AuthCard } from "./AuthCard";

export const minPasswordLength = 8;

/** Nastavení hesla z odkazu od vedoucího (pozvánka i zapomenuté heslo, F-AUTH-02, 03, R-09). */
export function SetPasswordPage() {
  const { t } = useTranslation();
  const errorText = useErrorText();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const userId = params.get("u");
  const token = params.get("t");
  const info = usePasswordLinkInfo(userId, token);
  const setPassword = useSetPassword();
  const form = useForm({
    initialValues: { password: "", confirm: "" },
    validate: {
      password: (value) => (value.length < minPasswordLength ? t("auth.password.tooShort", { min: minPasswordLength }) : null),
      confirm: (value, values) => (value !== values.password ? t("auth.password.mismatch") : null),
    },
  });

  if (!userId || !token || info.isError)
    return (
      <AuthCard title={t("auth.setPassword.title")}>
        <Alert color="red">{t("error.auth.link_invalid")}</Alert>
      </AuthCard>
    );
  if (info.isPending)
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );

  return (
    <AuthCard title={t("auth.setPassword.title")}>
      <Text>{t("auth.setPassword.greeting", { name: info.data.displayName })}</Text>
      <Text>
        {t("auth.setPassword.loginIs")} <b>{info.data.userName}</b>
      </Text>
      <form
        onSubmit={form.onSubmit(({ password }) =>
          setPassword.mutate({ userId, token, password }, { onSuccess: () => void navigate("/", { replace: true }) }),
        )}
      >
        <Stack>
          <PasswordInput
            label={t("auth.password.new")}
            autoComplete="new-password"
            size="lg"
            {...form.getInputProps("password")}
          />
          <PasswordInput
            label={t("auth.password.confirm")}
            autoComplete="new-password"
            size="lg"
            {...form.getInputProps("confirm")}
          />
          {setPassword.isError && <Alert color="red">{errorText(setPassword.error)}</Alert>}
          <Button type="submit" loading={setPassword.isPending} fullWidth>
            {t("auth.setPassword.submit")}
          </Button>
        </Stack>
      </form>
    </AuthCard>
  );
}
